import { render } from "./AirportTrafficStatisticView.vue?vue&type=template&id=0fb33a53&scoped=true"
import script from "./AirportTrafficStatisticView.vue?vue&type=script&lang=js"
export * from "./AirportTrafficStatisticView.vue?vue&type=script&lang=js"

import "./AirportTrafficStatisticView.vue?vue&type=style&index=0&id=0fb33a53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb33a53"]])

export default __exports__